"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurveyorService = void 0;
var _surveyor = require("../controllers/surveyor.controller");
var SurveyorService = {
  recipient: {
    // common
    uniqueReferenceNo: _surveyor.config.recipient + "/unique/reference-no",
    list: _surveyor.config.recipient + "/list",
    create: _surveyor.config.recipient,
    update: _surveyor.config.recipient,
    linkedFund: _surveyor.config.recipient + "/fund/list",
    saveLinkedFund: _surveyor.config.recipient + "/fund//link",
    lock: _surveyor.config.recipient + "/lock",
    lockBulk: _surveyor.config.recipient + "/bulk/lock",
    unlock: _surveyor.config.recipient + "/unlock",
    unlockBulk: _surveyor.config.recipient,
    softDelete: _surveyor.config.recipient + "/delete/soft",
    softDeleteBulk: _surveyor.config.recipient + "/bulk/delete/soft",
    submit: _surveyor.config.surveyRecipient + "/reponse/submit",
    submitBulk: _surveyor.config.surveyRecipient + "/reponse/bulk/submit",
    approve: _surveyor.config.surveyRecipient + "/reponse/approve",
    approveBulk: _surveyor.config.surveyRecipient + "/reponse/bulk/approve",
    copyUrl: _surveyor.config.recipient,
    download: _surveyor.config.recipient,
    downloadAll: _surveyor.config.recipient,
    downloadSurveyResponse: _surveyor.config.recipient,
    // deleted data
    softDeleteList: _surveyor.config.recipient + "/list/soft/deleted",
    restore: _surveyor.config.recipient + "/delete/soft/restore",
    restoreBulk: _surveyor.config.recipient + "/bulk/delete/soft/restore",
    delete: _surveyor.config.recipient,
    deleteBulk: _surveyor.config.recipient + "/bulk/delete",
    // uploader
    prefight: _surveyor.config.recipient,
    import: _surveyor.config.recipient,
    errorSheetDownload: _surveyor.config.recipient,
    // analytics
    analyticsSave: _surveyor.config.recipient,
    analyticsGet: _surveyor.config.recipient,
    analyticsUpdate: _surveyor.config.recipient
  },
  survey: {
    // common
    list: _surveyor.config.survey + "/list",
    fetch: _surveyor.config.survey,
    fetchPasscode: _surveyor.config.survey + "/passcode",
    create: _surveyor.config.survey,
    update: _surveyor.config.survey,
    linkedFund: _surveyor.config.survey,
    saveLinkedFund: _surveyor.config.survey + "/passcode",
    lock: _surveyor.config.survey + "/lock",
    lockBulk: _surveyor.config.survey + "/bulk/lock",
    unlock: _surveyor.config.survey + "/unlock",
    unlockBulk: _surveyor.config.survey + "/bulk/unlock",
    softDelete: _surveyor.config.survey + "/delete/soft",
    softDeleteBulk: _surveyor.config.survey + "/bulk/delete/soft",
    submit: _surveyor.config.survey + "/submit",
    submitBulk: _surveyor.config.survey + "/bulk/submit",
    pause: _surveyor.config.survey + "/pause",
    pauseBulk: _surveyor.config.survey + "/bulk/pause",
    resume: _surveyor.config.survey + "/resume",
    resumeBulk: _surveyor.config.survey + "/bulk/resume",
    copyUrl: _surveyor.config.survey + "/copy-url",
    magicUrl: _surveyor.config.survey + "/magic-link",
    downloadAll: _surveyor.config.survey,
    downloadSurveyResponse: _surveyor.config.survey,
    // deleted data
    softDeleteList: _surveyor.config.survey + "/list/soft/deleted",
    restore: _surveyor.config.survey + "/delete/soft/restore",
    restoreBulk: _surveyor.config.survey + "/bulk/delete/soft/restore",
    delete: _surveyor.config.survey + "",
    deleteBulk: _surveyor.config.survey + "/bulk/delete",
    // uploader
    prefight: _surveyor.config.survey,
    import: _surveyor.config.survey,
    errorSheetDownload: _surveyor.config.survey,
    // analytics
    analyticsSave: _surveyor.config.survey,
    analyticsGet: _surveyor.config.survey,
    analyticsUpdate: _surveyor.config.survey,
    // configuration
    listConfiguration: _surveyor.config.survey + "/configuration/list",
    fetchConfiguration: _surveyor.config.survey + "/configuration",
    // review and approve
    listReviewAndApprove: _surveyor.config.survey + "/recipient/reponse/list",
    approve: _surveyor.config.survey + "/recipient/reponse/submit",
    approveBulk: _surveyor.config.survey + "/recipient/reponse/bulk/submit"
  }
};
exports.SurveyorService = SurveyorService;